import { PaletteMode, createTheme, type ThemeOptions } from '@mui/material'
import { getColorFromEnv } from './palette/colors'

const getDesignTokens = (mode: PaletteMode): ThemeOptions => {
  return {
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiTextField: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiSelect: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiFormControl: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiInputLabel: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiButton: {
        defaultProps: {
          size: 'small',
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            '& .MuiCardContent-root': {
              padding: 12,
              '&:last-child': {
                paddingBottom: 12,
              },
            },
          },
        },
      },
      MuiAutocomplete: {
        defaultProps: {
          size: 'small',
        },
      },
    },
    palette: {
      mode,
      primary: {
        main: getColorFromEnv('primary'),
      },
      secondary: {
        main: getColorFromEnv('secondary'),
      },
      background: {
        default: getColorFromEnv('background'),
        paper: getColorFromEnv('background'),
      },
    },
    typography: {
      fontFamily: `"Cinzel"`,
      // Smaller default sizes for compact widget
      h6: {
        fontSize: '1rem',
      },
      subtitle1: {
        fontSize: '0.875rem',
      },
      subtitle2: {
        fontSize: '0.8rem',
      },
      body1: {
        fontSize: '0.875rem',
      },
      body2: {
        fontSize: '0.8rem',
      },
    },
  }
}

const theme = createTheme(getDesignTokens('light'), {})

export default theme
